import { useNavigate } from 'react-router-dom';

export function useMoveBack(path) {
  const navigate = useNavigate();
  return () => navigate(path ? path : -1);
}
